import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
`;

export const Content = styled.div`
  flex: 1;

  > div {
    padding: 0 15px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;
    max-height: 62vh;
    overflow-y: scroll;

    > h1 {
      margin-top: 1rem;
      grid-column-start: 1;
      grid-column-end: 5;
      align-items: center;
    }
  }

  > span {
    display: flex;
    align-items: center;

    > h1 {
      margin-left: 90px;
      margin-top: 15px;
      font-weight: 600;
      color: ${({ theme }) => theme.text};
      font-size: 1.75rem;
    }
  }

  @media (max-width: 1600px) {
    > div {
      max-height: 53vh;
    }
  }

  @media (max-width: 1470px) {
    > div {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 1110px) {
    > div {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 750px) {
    > div {
      padding: 0;
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 450px) {
    > span {
      > h1 {
        margin-left: 30px;
        font-size: 1.5rem;
      }
    }
  }

  @media (max-width: 415px) {
    h2 {
      margin-left: 35px;
      font-size: 1.5rem;
    }
  }

  @media (max-width: 380px) {
    > span {
      flex-direction: column;

      > h1 {
        margin-left: 0px;
        font-size: 1.5rem;
      }
    }
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;

  background: #dcdcdc;

  border: 2px solid ${({ theme }) => theme.icon};
  border-radius: 2px;

  padding: 0 6px;

  input {
    padding: 0 6px 0 10px;
    font-size: 1.25rem;
    line-height: 26px;
    background: #dcdcdc;
    color: ${({ theme }) => theme.black};
  }

  svg {
    color: ${({ theme }) => theme.black};
  }
`;
